import { useStores } from 'src/contexts/stores';

export default function useUI() {
  const { UI } = useStores();

  return UI;
}
